var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.58 9.7425L14.5725 9.7575C14.6025 9.51 14.6325 9.255 14.6325 9C14.6325 8.745 14.61 8.505 14.58 8.2575L14.5875 8.2725L16.4175 6.8325L14.595 3.6675L12.4425 4.5375L12.45 4.545C12.06 4.245 11.6325 3.99 11.1675 3.795H11.175L10.83 1.5H7.1775L6.8475 3.8025H6.855C6.39 3.9975 5.9625 4.2525 5.5725 4.5525L5.58 4.545L3.42 3.6675L1.59 6.8325L3.42 8.2725L3.4275 8.2575C3.3975 8.505 3.375 8.745 3.375 9C3.375 9.255 3.3975 9.51 3.435 9.7575L3.4275 9.7425L1.8525 10.98L1.605 11.175L3.4275 14.325L5.5875 13.4625L5.5725 13.4325C5.97 13.74 6.3975 13.995 6.87 14.19H6.8475L7.185 16.5H10.8225C10.8225 16.5 10.845 16.365 10.8675 16.185L11.1525 14.1975H11.145C11.61 14.0025 12.045 13.7475 12.4425 13.44L12.4275 13.47L14.5875 14.3325L16.41 11.1825C16.41 11.1825 16.305 11.0925 16.1625 10.9875L14.58 9.7425V9.7425ZM9 11.625C7.5525 11.625 6.375 10.4475 6.375 9C6.375 7.5525 7.5525 6.375 9 6.375C10.4475 6.375 11.625 7.5525 11.625 9C11.625 10.4475 10.4475 11.625 9 11.625Z",
    fill: "white",
    fillOpacity: 0.84
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a535849f774220019c0eb3c327e8f04c.svg";
export { ForwardRef as ReactComponent };